import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';

import { differenceInCalendarDays } from '@superbet-group/web.lib.utilities';

import { clientStorageWithExpiry } from '@core/clientStorage/clientStorageWithExpiry';
import User from '@models/user/User';

export interface idCardRemainingDaysData {
    user: User;
    serverPeriod?: number;
    overriddenCountry?: Country;
}

export function getReferenceFieldKey(country?: Country): keyof User {
    return country === Country.Ro ? 'firstDepositDate' : 'registrationDate';
}

export function idCardRemainingDays({
    user,
    serverPeriod,
    overriddenCountry,
} : idCardRemainingDaysData): number | null {
    const country = overriddenCountry || getConfig().countrySpecific.country;
    const referenceDate = user[getReferenceFieldKey(country)];
    const period = serverPeriod || getConfig().countrySpecific.user.idCardVerification.period;

    if (typeof referenceDate === 'boolean') {
        return null;
    }
    return Math.max(
        0,
        period - differenceInCalendarDays(new Date(), new Date(referenceDate)),
    );
}

export function hasUserCompletedSecondStep(user: User) {
    return user.isVerifiedIdCard
        || !!user.phone
        || clientStorageWithExpiry.get<boolean>(`user:${user.userId}:2ndStepCompleted`);
}

export function setUserCompletedSecondStep(user: User) {
    if (getConfig().countrySpecific.user.idCardVerification.isCompleteRegistrationNeededForKyc) {
        return clientStorageWithExpiry.set(`user:${user.userId}:2ndStepCompleted`, true);
    }
}
